import { render } from "./JsonSchemaDropdown.vue?vue&type=template&id=dcb83926&ts=true"
import script from "./JsonSchemaDropdown.vue?vue&type=script&lang=ts"
export * from "./JsonSchemaDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__